// Pool Cleaning & Maintenance Services Data

export const maintenanceServices = {
  hero: {
    headline: "Keep Your Pool Clean, Clear, and Ready Year-Round",
    subheadline: "Waterlife Pools & Spas provides dependable pool cleaning and maintenance for homeowners across Central Texas."
  },
  
  intro: {
    headline: "Reliable Pool Service You Can Count On",
    text: "Keeping your pool clean and balanced takes time, experience, and the right equipment. Waterlife Pools & Spas makes it easy with professional pool cleaning and maintenance services designed to keep your water clear, safe, and ready to enjoy. Whether you need weekly service or help getting your pool back in shape, we've got you covered."
  },
  
  servicesIncluded: [
    "Skimming surface debris",
    "Brushing walls and steps",
    "Vacuuming pool floor",
    "Cleaning skimmer and pump baskets",
    "Water testing and chemical balancing",
    "Equipment inspection",
    "Filter check and maintenance"
  ],
  
  chemicalService: {
    headline: "Water Testing & Chemical Balance",
    text: "Proper chemical balance is key to keeping your pool safe and preventing damage. We test and adjust your pool water to maintain:",
    items: [
      "Chlorine levels",
      "pH balance",
      "Alkalinity",
      "Calcium hardness"
    ],
    note: "This helps prevent algae growth, cloudy water, and equipment issues."
  },
  
  servicePlans: [
    {
      id: 1,
      name: "Basic Service",
      description: "Cleaning only",
      note: "Chemicals billed separately",
      features: ["Professional pool cleaning", "Weekly or bi-weekly visits", "Equipment inspection"]
    },
    {
      id: 2,
      name: "Full Service",
      description: "Cleaning + chemicals included",
      popular: true,
      features: ["Everything in Basic", "All chemicals included", "Water testing & balancing", "Monthly service report"]
    },
    {
      id: 3,
      name: "Premium Service",
      description: "Full service + priority scheduling and support",
      features: ["Everything in Full Service", "Priority scheduling", "24/7 emergency support", "Quarterly equipment tune-up"]
    }
  ],
  
  whyChoose: [
    "Reliable weekly service",
    "Clear communication",
    "Experienced technicians",
    "Affordable maintenance plans",
    "Fast response for issues"
  ],
  
  referral: {
    headline: "Referral Program",
    text: "Refer a new customer and receive FREE service once they get started."
  },
  
  pricing: {
    headline: "Affordable Pool Maintenance",
    text: "We offer competitive pricing and will meet or beat any written quote for comparable service."
  },
  
  serviceArea: {
    headline: "Serving Central Texas",
    cities: [
      "Waco",
      "Hewitt",
      "Woodway",
      "Lorena",
      "China Spring",
      "McGregor",
      "Temple",
      "Belton"
    ]
  }
};
